/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { fetchMetadata } from 'helpers/actionHelpers';

import API from 'constants/api';
import { DefaultResult } from 'components/archived-object/search/DefaultResults';

const ImportantInfoView = ({ uri, defaultImage }) => {
  const [loading, setLoading] = useState(false);
  const [object, setObject] = useState(null);

  useEffect(() => {
    setLoading(true);
    let windowId = sessionStorage.getItem("WINDOW_ID");
    fetchMetadata(`${API.UI.IMPORTANT_INFO}&uri=${uri}&windowId=${windowId}`)
      .then(object => {
        setObject(object);
        setLoading(false);
        setTimeout(() => window.parent.resizeIframe(), 100);
      })
  }, []);

  if (loading || !object) {
    return null;
  }

  return <DefaultResult 
    object={object} 
    defaultImage={defaultImage == null ? 'images/NoImage.jpg' : defaultImage}
    noLinks={true}
  />;
};

export default ImportantInfoView;